import { render, staticRenderFns } from "./Socials-tab.vue?vue&type=template&id=dadd2bf2&scoped=true&"
import script from "./Socials-tab.vue?vue&type=script&lang=js&"
export * from "./Socials-tab.vue?vue&type=script&lang=js&"
import style0 from "./Socials-tab.vue?vue&type=style&index=0&id=dadd2bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadd2bf2",
  null
  
)

export default component.exports